import { get } from 'lodash-es'
import type { PaginationUrlFilterSingleType } from '@/services/tables/types'
import type { Dict } from '@/types'

export type FilterValue = string | number | boolean // feel free to add everything you need

const makeEqSingleFilter = (key: string, value: FilterValue): PaginationUrlFilterSingleType => ({
  [key]: { eq: String(value) },
})

export const makeEqFilter = (filter: Dict<FilterValue>): PaginationUrlFilterSingleType =>
  Object.entries(filter).reduce(
    (sum, [key, value]) => ({
      ...sum,
      ...makeEqSingleFilter(key, value),
    }),
    {},
  )

export const makeEqIdFilter = (value) => makeEqSingleFilter('id', value)

export const getEqIdFilterValue = (filter: PaginationUrlFilterSingleType, param: string): string =>
  get(filter, [param, 'id', 'eq'])

export const getEqFilterValue = (filter: PaginationUrlFilterSingleType, param: string): string =>
  get(filter, [param, 'eq'])
